/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMarketHistoryRequest} from '@cash-web/protos/squareup/cash/marketprices/service.pb'
import {GetMarketHistoryResponse} from '@cash-web/protos/squareup/cash/marketprices/service.pb'


export const getMarketHistory = (request: GetMarketHistoryRequest, options?: CashRequestOptions) => post<GetMarketHistoryRequest, GetMarketHistoryResponse>("/2.0/cash/get-market-history", request, {...options, rejectOnError: true })